<template>
  <div>

    <div class=" q-position-relative get-the-look__stylisation-container" v-if="hasGetTheLooks">

      <ComponentLoader :loading="getGetTheLookLoading"/>
      <swiper
          class="swiper"
          :navigation="true"
          :modules="modules"
          :space-between="30"
          :slides-per-view="1"
          :centered-slides="false"
          :pagination="{ clickable: true }"
      >

        <swiper-slide class="slide" v-for="stylisationSet in preparedProducts" :key="stylisationSet.setNumber">
          <div class="q-row mb-5  stylisation__collage--container q-position-relative"
               style="background-color: #f2f2f2; min-height: 500px; max-width: 460px; margin: auto">
            <CollagesComponentBoxCat :products="stylisationSet.products"/>
            <CollagesInfoComponent :products="stylisationSet.products"/>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script setup lang="ts">

import {onMounted, ref, defineProps, PropType, computed} from 'vue'
import ComponentLoader from '@/components/ComponentLoader.vue'
import {Navigation, Pagination} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import {storeToRefs} from 'pinia'
import {useGetTheLookStore} from '@/store/getTheLookStore'
import CollagesComponentBoxCat from "@/components/StylisationCollage/CollagesComponentBoxCat.vue";
import CollagesInfoComponent from "@/components/StylisationCollage/CollagesInfoComponent.vue";

defineProps({
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
});

const modules = ref([Pagination, Navigation])

const getTheLookStore = useGetTheLookStore()

const {getGetTheLooksCategorized, getGetTheLookLoading, hasGetTheLooks} = storeToRefs(getTheLookStore)

const preparedProducts = computed(() => {
  const output = []
  const set_0 = {
    setNumber: 0,
    products: []
  }
  const set_1 = {
    setNumber: 1,
    products: []
  }
  const set_2 = {
    setNumber: 2,
    products: []
  }
  getGetTheLooksCategorized.value.forEach(categorySet => {

    typeof categorySet.products[0] !== 'undefined' && set_0.products.push(categorySet.products[0])
    typeof categorySet.products[1] !== 'undefined' ? set_1.products.push(categorySet.products[1]) : set_1.products.push(categorySet.products[categorySet.products.length - 1])
    typeof categorySet.products[2] !== 'undefined' ? set_2.products.push(categorySet.products[2]) : set_2.products.push(categorySet.products[categorySet.products.length - 1])

  })
  output.push(set_0)
  output.push(set_1)
  output.push(set_2)
  console.log('output', output)
  return output
})

onMounted(async () => {
  await getTheLookStore.fetchGetTheLooksCategorized()
  console.log(getGetTheLooksCategorized.value)
})

</script>
<style>


</style>

